import { SET_AGENT_SESSION_TOKEN } from 'actions/agentDeployActions';

const initialState = { agentSessionToken: null };

export default function agentDeploy(state = initialState, action) {
  switch (action.type) {
    case SET_AGENT_SESSION_TOKEN:
      return { ...state, agentSessionToken: action.agentSessionToken };
    default:
      return state;
  }
}
